import { format } from 'date-fns';

export const getDateDisplay = (date: Date, form?: string) =>
    `${format(date, form || 'EEEE MMM d, y')}`;
